import React, { useEffect, useRef } from 'react';

import { useProfileState, useProfileActions } from './ProfileContext';

import SearchBar from '../../Shared/UI/SearchBar/components/SearchBar';

import { getInterests } from './restApi';

const NewUnrecognizedInterestFormForModal = () => {
  const state = useProfileState();
  const { onResponse, onError, setInterestsModalToLoading, updateDebouncedInterestNameForFuzzyFilter, updateNewInterestName } = useProfileActions();
  const searchBarRef = useRef(null);

  useEffect(() => {
    setInterestsModalToLoading();

    const handler = setTimeout(() => {
      updateDebouncedInterestNameForFuzzyFilter(state?.interestsModal?.newUnrecognizedInterestForm?.interestName);
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [state?.interestsModal?.newUnrecognizedInterestForm?.interestName]);


  useEffect(() => {
    getInterests({
      onResponse,
      onError,
      pageNumber: 1,
      debouncedInterestNameForFuzzyFilter: state?.interestsModal?.newUnrecognizedInterestForm?.debouncedInterestNameForFuzzyFilter,
      interestName: state?.interestsModal?.newUnrecognizedInterestForm?.interestName,
    });
  }, [state?.interestsModal?.newUnrecognizedInterestForm?.debouncedInterestNameForFuzzyFilter]);

  useEffect(() => {
    if (state.userInterestsModalIsOpen && searchBarRef.current) {
      // Small delay to ensure modal is fully rendered
      const timeoutId = setTimeout(() => {
        searchBarRef.current?.focus();
      }, 100);
      return () => clearTimeout(timeoutId);
    }
  }, [state.userInterestsModalIsOpen]);

  return (
    <SearchBar
      ref={searchBarRef}
      placeholder="Search Interest And Add If Not Found..."
      value={state?.interestsModal?.newUnrecognizedInterestForm?.interestName}
      onChange={
        (e) => {
          updateNewInterestName(e.target.value);
        }
      }
    />
  );
};

export default NewUnrecognizedInterestFormForModal;
